/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'

const IconClose = props => {
  const { className, width = 24, height = 24, onClick, style } = props
  const title = 'icon-close'
  const dataTestId = props['data-testid'] || title

  return (
    <svg
      className={className}
      style={style}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      onClick={onClick}
      data-testid={dataTestId}
    >
      <g data-rebalance="1.384" transform="translate(12 12) scale(1.384) translate(-12 -12)">
        <title>{title}</title>
        <path d="M19.008 6.408l-1.416-1.416-5.592 5.592-5.592-5.592-1.416 1.416 5.592 5.592-5.592 5.592 1.416 1.416 5.592-5.592 5.592 5.592 1.416-1.416-5.592-5.592z" />
      </g>
    </svg>
  )
}

export default IconClose
